import { Product, AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import { IDealFetchResult } from '@/creditflowresearch/application/Deal/helpers/dealFetcher/types/IDealFetcher';

const PRODUCT_TO_DEAL_KEY: Record<string, keyof IDealFetchResult> = {
  [AbsProduct.ABBREVIATION]: 'abs',
  [HycProduct.ABBREVIATION]: 'corporate',
  [IgcProduct.ABBREVIATION]: 'corporate',
  LM: 'corporate',
  CORPORATE: 'corporate',
};

export const getDealsByActiveProduct = (deals: IDealFetchResult, activeProductIds: string | string[]) => {
  const productIds = Array.isArray(activeProductIds) ? activeProductIds : [activeProductIds];

  const validProduct = productIds.find((productId) => {
    const abbreviation = Product.getAbbreviation(productId);
    return abbreviation && PRODUCT_TO_DEAL_KEY[abbreviation];
  });

  const abbreviation = Product.getAbbreviation(validProduct);
  const dealKey = PRODUCT_TO_DEAL_KEY[abbreviation];
  return deals[dealKey];
};
